(() => {
  'use strict';

  const normalize = (value = '') => value
    .toLocaleLowerCase('lt-LT')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[„“”"']/g, '')
    .replace(/\s+/g, ' ')
    .trim();

  const mapQuery = (raw) => {
    const q = normalize(raw);
    if (!q) return raw;

    if (/gimimo|metrik|naujagim|kudikio duomen/.test(q)) return 'gimimo';
    if (/taupykl|pinig.*dez|monet.*dez/.test(q)) return 'taupyklė';
    if ((/vard/.test(q) && /dekor|zenkl|raide|uzras/.test(q)) || /vardu dekoracijos/.test(q)) return 'vardo';
    if (/raktu? pakab|pakabuk/.test(q)) return 'pakabukas';
    return raw.trim();
  };

  const ensureProductType = (form) => {
    let type = form.querySelector('input[name="type"]');
    if (!type) {
      type = document.createElement('input');
      type.type = 'hidden';
      type.name = 'type';
      form.appendChild(type);
    }
    type.value = 'product';
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/search"], form[role="search"]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    input.value = mapQuery(input.value);
    ensureProductType(form);
  }, true);

  // Correct old bookmarked/category URLs such as q="gimimo metrika".
  const url = new URL(window.location.href);
  if (/\/search\/?$/.test(url.pathname)) {
    const original = url.searchParams.get('q') || '';
    const mapped = mapQuery(original);
    const currentType = url.searchParams.get('type');
    if (mapped && (mapped !== original || currentType !== 'product')) {
      url.searchParams.set('q', mapped);
      url.searchParams.set('type', 'product');
      window.location.replace(url.toString());
    }
  }


  // Present category searches as proper category pages, not as a technical search.
  const friendlyCategory = (raw) => {
    const q = normalize(raw);
    if (q === 'gimimo') return 'Gimimo metrikos';
    if (q === 'vardo') return 'Vardų dekoracijos';
    if (q === 'taupykle') return 'Taupyklės';
    if (q === 'pakabukas') return 'Raktų pakabukai';
    return '';
  };

  const applyFriendlySearchPresentation = () => {
    const current = new URL(window.location.href);
    if (!/\/search\/?$/.test(current.pathname)) return;
    const label = friendlyCategory(current.searchParams.get('q') || '');
    if (!label) return;

    document.documentElement.dataset.nlCategorySearch = 'true';
    const main = document.querySelector('main') || document;
    const heading = main.querySelector('h1');
    if (heading) heading.textContent = label;

    main.querySelectorAll('input[name="q"]').forEach((input) => {
      input.value = label;
      input.setAttribute('aria-label', `Ieškoti kategorijoje „${label}“`);
    });

    if (document.title) {
      document.title = document.title.replace(/Paieškos rezultatai[^|–-]*/i, label);
    }

    const active = document.querySelector('.nl-category-nav__link.is-active');
    active?.scrollIntoView({ block: 'nearest', inline: 'center' });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFriendlySearchPresentation, { once: true });
  } else {
    applyFriendlySearchPresentation();
  }

})();
